import { Helmet } from 'react-helmet-async';
import { Wordmark } from '../components/layout/Wordmark.jsx';

/**
 * Maintenance mode, toggled from Settings. It replaces the whole shell rather
 * than sitting inside it — a header linking to pages that are also closed is
 * worse than no header.
 *
 * The admin panel stays open throughout, which is the point of the toggle.
 */
export const Maintenance = ({ message, storeName = 'Golden Era' }) => (
  <>
    <Helmet>
      <title>Back shortly — {storeName}</title>
      <meta name="robots" content="noindex" />
    </Helmet>

    <main className="grid min-h-screen place-items-center bg-paper px-6">
      <div className="w-full max-w-md text-center">
        <Wordmark className="mx-auto h-10" />

        <p className="mt-12 font-mono text-2xs tracking-[0.16em] text-muted uppercase">
          Closed briefly
        </p>
        <h1 className="mt-3 font-display text-2xl tracking-[-0.02em] text-ink">Back shortly</h1>
        <p className="mt-3 text-sm leading-relaxed text-muted">
          {message || 'We are making a few changes and will be back within the hour.'}
        </p>

        <p className="mt-10 text-xs text-muted">
          Orders already placed are unaffected and will ship as normal.
        </p>
      </div>
    </main>
  </>
);

export default Maintenance;
